export default "__VITE_ASSET__BrOHShCK__"